export const base64ToFile = (params: {
  base64String: string;
  fileName: string;
  mimeType: string;
}): File => {
  const extension = params.mimeType.split("/")[1];
  const fileNameWithExtension = `${params.fileName}.${extension}`;

  const byteCharacters = atob(params.base64String);

  const byteArrays = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays[i] = byteCharacters.charCodeAt(i);
  }

  const blob = new Blob([byteArrays], { type: params.mimeType });

  return new File([blob], fileNameWithExtension, { type: params.mimeType });
};
